import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseReviewSectionLeadProps {
  establishmentLeadId?: string
  state?: string
  section: string,
  payload?: any,
  onSuccess?: () => void
  onError?: () => void
}

const useReviewSectionLead = ({ establishmentLeadId, state, section, payload, onSuccess, onError }: UseReviewSectionLeadProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['reviewSectionLead'],
    mutationFn: async (data?: { description?: string }) => {
      const lead = {
        [section]: {
          last_review_attributes: {
            state,
            description: data?.description
          },
          ...payload
        }
      }

      await privateAxios.putForm(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}

export default useReviewSectionLead